import { HeaderAndTableCellDraft, SortAttributes } from '@markant-platform/shared/table/model';

export const TABLE_HEADER_AND_CELLS_EMPLOYEES: HeaderAndTableCellDraft[] = [
  {
    headerCellColumnId: 'name',
    headerCellTranslationKey: 'common.name',
    tableCellContentKey: 'fullName',
    tableCellContentType: 'STRING',
    tableCellTruncate: true,
  },
];

export const TABLE_HEADER_AND_CELLS_ASSIGNED_EMPLOYEES: HeaderAndTableCellDraft[] = [
  {
    headerCellColumnId: 'name',
    headerCellTranslationKey: 'common.name',
    tableCellContentKey: 'fullName',
    tableCellContentType: 'STRING',
    tableCellTruncate: true,
  },
];

export const DEFAULT_SORT_ASSIGNED_EMPLOYEES: SortAttributes = {
  sortField: 'name',
  sortOrder: 'asc',
};

export const DEFAULT_SORT_EMPLOYEES: SortAttributes = {
  sortField: 'name',
  sortOrder: 'asc',
};
